import moment from 'moment';

export const formatDateTime = dateTime => 
  moment(dateTime).format('Do MMMM YYYY HH:mma');

export default formatDateTime;
